import { CloseReviewEntryPresenter } from '@/presentation/presenters/review/closeReviewEntryPresenter'
import { CloseReviewEntryViewModel } from '@/presentation/viewmodels/review/closeReviewEntryViewModel'

export function useCloseReviewEntryPresenter(
  presenter: CloseReviewEntryPresenter = new CloseReviewEntryPresenter(new CloseReviewEntryViewModel())
) {
  return {
    entryList: presenter.entryList,
    isLoading: presenter.isLoading,
    error: presenter.error,
    hasEntryInList: presenter.hasEntryInList,
    fetchEntryList: presenter.fetchReviewEntryList.bind(presenter)
  }
}
